module.exports = __webpack_public_path__ + "3c264849ff4eb9b6e99eab9cd54c80ae.ttf";